import React, { createContext, useContext } from 'react';

export interface FormRowMeta {
  index: number;
  total: number;
  isFirst: boolean;
  isLast: boolean;
  /** Document category from the parent FormEachNode, when set. */
  documentCategory?: string;
  /** When true, field labels are rendered in the table header — suppress per-cell labels. */
  tablePresentation?: boolean;
}

const FormRowContext = createContext<FormRowMeta | null>(null);

export function FormRowProvider({
  value,
  children,
}: {
  value: FormRowMeta;
  children: React.ReactNode;
}): React.ReactElement {
  return <FormRowContext.Provider value={value}>{children}</FormRowContext.Provider>;
}

export function useFormRowMeta(): FormRowMeta | null {
  return useContext(FormRowContext);
}

/** Values selected in sibling rows that should be excluded from options. */
const FormRowExcludedValuesContext = createContext<Record<string, unknown[]> | null>(null);

export function FormRowExcludedValuesProvider({
  value,
  children,
}: {
  value: Record<string, unknown[]>;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <FormRowExcludedValuesContext.Provider value={value}>
      {children}
    </FormRowExcludedValuesContext.Provider>
  );
}

export function useFormRowExcludedValues(): Record<string, unknown[]> | null {
  return useContext(FormRowExcludedValuesContext);
}
